import MuiDialog, { type DialogProps } from "@mui/material/Dialog";
import MuiDialogTitle, { type DialogTitleProps } from "@mui/material/DialogTitle";
import MuiDialogContent, { type DialogContentProps } from "@mui/material/DialogContent";
import MuiDialogActions, { type DialogActionsProps } from "@mui/material/DialogActions";
import MuiDialogContentText, { type DialogContentTextProps } from "@mui/material/DialogContentText";

export type {
  DialogProps,
  DialogTitleProps,
  DialogContentProps,
  DialogActionsProps,
  DialogContentTextProps,
};

export function Dialog(props: DialogProps) {
  return <MuiDialog {...props} />;
}

export function DialogTitle(props: DialogTitleProps) {
  return <MuiDialogTitle {...props} />;
}

export function DialogContent(props: DialogContentProps) {
  return <MuiDialogContent {...props} />;
}

export function DialogActions(props: DialogActionsProps) {
  return <MuiDialogActions {...props} />;
}

export function DialogContentText(props: DialogContentTextProps) {
  return <MuiDialogContentText {...props} />;
}
